import style from "./Tag.css";
const Tag = ({ text, selected, onClick, hasDropdown, id, shouldTruncate }) => {
  const conditionalRenderTextStyle = () =>
    shouldTruncate ? style.textContainerEllipsis : "";

  return (
    <div
      id={id}
      class={selected ? style.selectedTag : style.tag}
      onClick={onClick}
    >
      <div class={conditionalRenderTextStyle()}>{text}</div>
      {hasDropdown && <div class={style.chevron}></div>}
    </div>
  );
};

export { Tag };
